import type { DietType } from '@/store/types'

import type { DayFormat, PrintOptions } from './types'

export function buildPrintUrl(input: {
  dayFormat: DayFormat
  dietId: number
  dietType: DietType
  hasAssignedDate: boolean
  hasFullPrint: boolean
  hasLimitedPrint: boolean
  host: string
  options: PrintOptions
  systemDietId: string | number
  testPrint: boolean
  token: string
}) {
  const params = new URLSearchParams({
    diet_type: input.dayFormat,
    group_by: input.options.groupBy,
    print_inevitable_losses: String(input.options.printInevitableLosses),
    separate_days_or_meals: String(input.options.separateDaysOrMeals),
    show_chosen_nutrients: String(input.options.showChosenNutrients),
    show_comments: String(input.options.showComments),
    show_consolidated_shopping_list: String(input.options.showConsolidatedShoppingList),
    show_date: String(input.dayFormat === 'days_of_week' && input.hasAssignedDate),
    show_kcalmar_logo: String(input.options.showKcalmarLogo),
    show_meal_hour: String(input.options.showMealHour),
    show_nutrients: String(input.options.showNutrients),
    show_preparation_time: String(input.options.showPreparationTime),
    show_qr_codes: String(input.options.showQRCodes),
    show_shopping_list: String(input.options.showShoppingList),
    show_week: String(input.options.showWeek),
    sort_by: input.options.sortBy,
    theme: input.options.theme,
    token: input.token,
    type: input.hasFullPrint || input.hasLimitedPrint ? input.dietType : 'system',
  })
  const id =
    input.hasFullPrint || input.hasLimitedPrint
      ? input.dietId
      : input.testPrint
        ? input.systemDietId
        : 648411
  return `${input.host}/pdf/new-diet/${id}/?${params}`
}
